var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lesson"},[_c('div',{staticClass:"fixed"},[_c('el-steps',{attrs:{"active":0,"align-center":""}},_vm._l((_vm.lesson.episodes),function(item,index){return _c('el-step',{key:index,attrs:{"episode":item}})}),1)],1),_vm._v(" "),_c('span',{staticClass:"h2"},[_vm._v("\n\t\t"+_vm._s(_vm.lesson.title)+"\n\t")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.lesson.brief)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52f3a5bc","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vLesson.vue
// module id = 175
// module chunks = 1